import { toast } from "react-toastify";
import "./toast.css";
import successAudio from "./audio/success.mp3";
import errorAudio from "./audio/error.mp3";
import infoAudio from "./audio/info.mp3";

export const ToastMessage = async (TYPE, MESSAGE) => {
  // const bgColor = TYPE === 1 ? "#aeccea" : TYPE === 2 ? "#8ba98e" : "#dac8ca";
  const toastStyle = {
    // backgroundColor: bgColor,
    marginTop: "20px",
    width: "80%",
    // color: "#383636",
  };
  const progressClassName = "toast-progress-white";
  const Success = new Audio(successAudio);
  const Error = new Audio(errorAudio);
  const Info = new Audio(infoAudio);

  if (TYPE === 1) {  //info
    toast.info(MESSAGE, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    Info.play();
  } else if (TYPE === 2) {  //success
    toast.success(MESSAGE, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    Success.play();
  } else if (TYPE === 3) {  //error
    toast.error(MESSAGE, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    Error.play();
  }
};
